import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home/home'
import index from '@/components/index'
import role from '@/components/role/roleList'
import code from '@/components/code/codeList'
import user from '@/components/user/list'
import global_ from '../utils/Global.js'
import print from '@/components/common/print'

// 此处引用其他业务使用的router文件
import chart from './chart.js'
import login from './login.js'
import addressBook from './addressBook.js'
import dept from './dept.js'
import menu from './menu.js'
import check from './check.js'

Vue.use(Router)
let childrenArr = [
  {
    path: '/',
    name: '/',
    component: home,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/home',
    name: 'home',
    component: home,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/role',
    name: 'role',
    component: role,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/user',
    name: 'user',
    component: user,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/code',
    name: 'code',
    component: code,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/print',
    name: 'print',
    component: print,
    meta: {
      requiresAuth: false
    },
  }
]
childrenArr = childrenArr.concat(chart.routes);
childrenArr = childrenArr.concat(addressBook.routes);
childrenArr = childrenArr.concat(dept.routes);
childrenArr = childrenArr.concat(menu.routes);
childrenArr = childrenArr.concat(check.routes);
let routersArr = [
  {
    path: '/',
    //name: 'index',
    component: index,
    meta: {
      requiresAuth: false
    },
    children: childrenArr
  },
];
//每增加一项业务就增加一条路由
routersArr = routersArr.concat(login.routes);

const router = new Router({
  routes: routersArr
})

router.beforeEach((to, from, next) => {
  // route.matched 返回一个数组，包含当前路由对象的所有嵌套路径片段的路由记录
  // .some() 方法测试数组中的某些元素是否通过了指定函数的测试
  // 此处查看是否有路由记录的 meta.requiresAuth 返回 true ，返回 true 则进入 if
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let token = window.localStorage.getItem(global_.USER_TOKEN);
    if (!token || token === null || token === 'null') {
      next({ path: '/login' });
    } else {
      var list = window.localStorage.getItem(global_.USER_AUTH);
      if (list === null) list = '';
      var rs = list.indexOf(to.path);
      if (rs > -1) {
        next();
      } else {
        window.localStorage.removeItem(global_.USER_TOKEN);
        window.localStorage.removeItem(global_.USER_AUTH);
        window.localStorage.removeItem(global_.USER_MENU);
        window.localStorage.removeItem(global_.USER_MENU_BUTTON);
        window.localStorage.removeItem(global_.USER_INFO);
        next({ path: '/login' });
      }
    }
  } else {
    next();
  }

})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js